import { Component } from '@angular/core';
import { TransferHttpService } from '../../services/transfer-http/transfer-http.service';
import { Router } from '@angular/router';
import { PermissionsService } from '../../services/permissions/permissions.service';


@Component({
  selector: 'managementDashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class ManagementDashboardComponent {

  constructor(private transferHttp: TransferHttpService,
    private router: Router,
    public permissions: PermissionsService) { }

  //***************************
  // Variables
  //***************************

  //Spinner
  spinnerText: string = "Loading...";
  showSpinner: boolean = false;

  //***************************
  // Functions
  //***************************

  defaultCLIN() {
    return JSON.stringify({ CLIN: 23, CY: new Date().getFullYear().toString().substr(-2), From: null, To: null });
  }

  dswReport() {
    return JSON.stringify({ CLIN: null, CY: null });
  }

  //***************************
  // Init
  //***************************

  ngOnInit(): void {
  }

}
